"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SemanticIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Icon = require("./Icon");
var _SemanticIconModule = _interopRequireDefault(require("./SemanticIcon.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SemanticIcon = _ref => {
  let {
    semantic = 'neutral',
    classNames,
    size = 'medium',
    testId,
    ...iconProps
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !!iconProps.name && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'wrapper'
      }),
      className: (0, _classify.default)(_SemanticIconModule.default.iconContainer, _SemanticIconModule.default[semantic], _SemanticIconModule.default[size], classNames?.wrapper, {
        [_SemanticIconModule.default.disabled]: iconProps.disabled
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        ...iconProps,
        className: (0, _classify.default)(iconProps.className, classNames?.icon),
        color: iconProps.disabled ? 'disabled' : _typography.TEXT_COLORS[semantic],
        size: size === 'large' ? 'medium' : size,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'icon'
        })
      })
    })
  });
};
exports.SemanticIcon = SemanticIcon;